const SkeletonForDetailsPage = () => {
  return (
    <div className="bg-gray-50 min-h-screen p-6">
      <div className="max-w-[90vw] mx-auto">
        {/* Breadcrumb skeleton */}
        <div className="flex items-center space-x-2 mb-6">
          <div className="h-4 bg-gray-300 rounded w-20 animate-pulse"></div>
          <div className="h-4 bg-gray-300 rounded w-4 animate-pulse"></div>
          <div className="h-4 bg-gray-300 rounded w-32 animate-pulse"></div>
        </div>

        {/* Main content skeleton */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-start space-x-6 mb-8">
            <div className="w-32 h-32 bg-gray-300 rounded-lg animate-pulse"></div>
            <div className="flex-1">
              <div className="flex items-center space-x-4 mb-4">
                <div className="h-6 bg-gray-300 rounded w-40 animate-pulse"></div>
                <div className="h-6 bg-gray-300 rounded w-20 animate-pulse"></div>
              </div>
              <div className="h-4 bg-gray-300 rounded w-48 mb-2 animate-pulse"></div>
              <div className="grid grid-cols-5 gap-8">
                {[...Array(5)].map((_, i) => (
                  <div key={i}>
                    <div className="h-4 bg-gray-300 rounded w-20 mb-1 animate-pulse"></div>
                    <div className="h-4 bg-gray-300 rounded w-24 animate-pulse"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Stats skeleton */}
          <div className="grid grid-cols-5 gap-6 mb-8">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gray-300 rounded animate-pulse"></div>
                  <div>
                    <div className="h-6 bg-gray-300 rounded w-12 mb-1 animate-pulse"></div>
                    <div className="h-4 bg-gray-300 rounded w-16 animate-pulse"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Tabs skeleton */}
          <div className="border-b mb-6">
            <div className="flex space-x-8">
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  className="h-4 bg-gray-300 rounded w-20 mb-4 animate-pulse"
                ></div>
              ))}
            </div>
          </div>

          {/* Table skeleton */}
          <div>
            <div className="h-6 bg-gray-300 rounded w-24 mb-4 animate-pulse"></div>
            <div className="space-y-3">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="grid grid-cols-8 gap-4 py-3">
                  {[...Array(8)].map((_, j) => (
                    <div
                      key={j}
                      className="h-4 bg-gray-300 rounded animate-pulse"
                    ></div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonForDetailsPage;
